import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row, Button } from '_zari/core'

import { TiposDocumentoSerieConstant, TiposDocumentoSunatConstant } from 'constants/index'

import * as UsuarioService from 'services/usuario.service'

const SerieNumeroFormGroup = ({
  fIsSubmitting,
  vId,
  vTipoDocumento,
  setFieldValue,
  flagEditarComentarios,
  flagGrifo,
  vSerieReferencia,
  flagSerieContingencia,
  mostrarSeriesModal,
  handleChange
}) => {
  const [series, setSeries] = React.useState([])

  React.useEffect(() => {
    if (!flagSerieContingencia) {
      if (!vId) {
        setFieldValue('serieDocumento', '')
        setSeries([])
      }

      if (vTipoDocumento) {
        let tipoSerie = ''
        if (vTipoDocumento === TiposDocumentoSunatConstant.BOLETA) {
          tipoSerie = TiposDocumentoSerieConstant.VENTAS_BOLETA
        } else if (vTipoDocumento === TiposDocumentoSunatConstant.FACTURA) {
          tipoSerie = TiposDocumentoSerieConstant.VENTAS_FACTURA
        } else if (vTipoDocumento === TiposDocumentoSunatConstant.NOTA_CREDITO) {
          if (vSerieReferencia.startsWith('F')) {
            tipoSerie = TiposDocumentoSerieConstant.VENTAS_NOTACREDITO_FACTURA
          } else {
            tipoSerie = TiposDocumentoSerieConstant.VENTAS_NOTACREDITO_BOLETA
          }
        } else if (vTipoDocumento === TiposDocumentoSunatConstant.OTROS) {
          tipoSerie = TiposDocumentoSerieConstant.VENTAS_TICKET
        }

        UsuarioService.self.obtenerSeriesxTipoSerie({ tipoSerie: tipoSerie }).then(({ data }) => {
          if (data && data.length > 0) {
            setSeries(data)
            if (!vId) {
              setFieldValue('serieDocumento', data[0])
              setFieldValue('tipoSerie', tipoSerie)
            }
          }
        })
      }
    }
  }, [vSerieReferencia, vTipoDocumento, setFieldValue, vId, flagSerieContingencia])

  const onChangeCheck = React.useCallback(
    e => {
      handleChange(e)

      const checked = e.currentTarget.checked
      if (checked) {
        setFieldValue('serieDocumento', '')
        setFieldValue('numeroDocumento', '')
      } else {
        setFieldValue('numeroDocumento', '')
      }
    },
    [handleChange, setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='SERIE' htmlFor='select-serie' md={flagGrifo ? 6 : 4} alignRightAt='md' />
        <Col md={flagGrifo ? 6 : 8}>
          <Row>
            <Col xs={5} sm={6} md={12}>
              <Form.InputGroup>
                {flagSerieContingencia ? (
                  <Field name='serieDocumento'>
                    {({ field }) => (
                      <Form.InputText
                        {...field}
                        id='input-serieDocumento'
                        disabled={fIsSubmitting || flagEditarComentarios}
                      />
                    )}
                  </Field>
                ) : (
                  <Field name='serieDocumento'>
                    {({ field }) => (
                      <Form.Select
                        {...field}
                        disabled={fIsSubmitting || flagEditarComentarios || !!vId}
                        id='select-serie'
                      >
                        {series.map(x => (
                          <option key={x} value={x}>
                            {x}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  </Field>
                )}
                <Form.InputGroup.Append>
                  <Button onClick={mostrarSeriesModal}>o</Button>
                </Form.InputGroup.Append>
              </Form.InputGroup>
            </Col>
            {vId || flagSerieContingencia ? (
              <Col xs={7} sm={6} md={12}>
                <Form.InputGroup>
                  <Field name='numeroDocumento'>
                    {({ field }) => (
                      <Form.InputText
                        {...field}
                        id='input-numeroDocumento'
                        disabled={!flagSerieContingencia}
                        style={{
                          padding: '.5rem .6rem'
                        }}
                      />
                    )}
                  </Field>
                </Form.InputGroup>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Form.Group>

      <Form.Group>
        <Col md={flagGrifo ? 6 : 4} />
        <Col md={flagGrifo ? 6 : 8}>
          <Field name='flagSerieContingencia'>
            {({ field }) => (
              <Form.Checkbox
                {...field}
                checked={flagSerieContingencia}
                disabled={fIsSubmitting}
                onChange={onChangeCheck}
                id='checkbox-flagSerieContingencia'
                label='Serie contingencia'
              />
            )}
          </Field>
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
